import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('company', [
      'companyThemeSetting'
    ]),
    hasCustomTheme () {
      return this.companyThemeSetting?.has_custom_theme
    },
    mobileCustomMenuList () {
      if (!this.hasCustomTheme) {
        return null
      }
      return this.companyThemeSetting.personalHomeMobileSetting.menuList
    },
    pcCustomMenuList () {
      if (!this.hasCustomTheme) {
        return null
      }
      return this.companyThemeSetting.personalHomePCSetting.menuList
    }
  }
}
